/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_7Inputs */



/**
* | output |
* | --- |
* | "Pre-built 3rd party platform integrations" |
*
* @param {Signup_Feature_Pro_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_7 = /** @type {((inputs?: Signup_Feature_Pro_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
	return /** @type {LocalizedString} */ ("Pre-built 3rd party platform integrations")
});